import { Box, ListItem, ListItemProps, Text, UnorderedList, VStack } from '@chakra-ui/react'
import { Bold, BoxSubheader2, DefaultModal, DefaultModalProps, useFormsView } from '@hb/react-web'
import { useCallback } from 'react'
import { Disclaimer } from '../../Assessment/Disclaimer'

const DisclaimerListItem = (props: ListItemProps) => (
  <ListItem {...props} fontSize="md" fontWeight={500} color="gray.600" fontFamily="Open Sans" />
)

export const AssessmentDisclaimers = ({ onCompleted }: { onCompleted?: () => void }) => {
  const { assessment } = useFormsView()
  const { disclaimers } = assessment.assessmentData ?? {}
  const { disclaimer1Accepted, disclaimer2Accepted } = disclaimers ?? { 1: false, 2: false }

  const handleCompleted = useCallback(
    (index: 1 | 2) => {
      if (!onCompleted) return
      if (index === 1) {
        if (disclaimer2Accepted) {
          onCompleted()
        }
      } else if (index === 2) {
        if (disclaimer1Accepted) {
          onCompleted()
        }
      }
    },
    [onCompleted, disclaimer1Accepted, disclaimer2Accepted],
  )

  return (
    <VStack px={1} w="100%">
      <Box w="100%">
        <BoxSubheader2 pr="30px">
          Please read the following terms before viewing your assessment
        </BoxSubheader2>
      </Box>
      <Disclaimer
        index={1}
        title="Disclaimer 1"
        accepted={!!disclaimer1Accepted}
        onCompleted={index => handleCompleted(index as 1 | 2)}>
        <Text fontWeight={500} color="gray.600" fontFamily="Open Sans">
          I understand the following assessment is contingent upon the information my insurer has
          provided to Hamilton Billing. I also understand it is my responsibility to further verify
          information with my insurer on coverage if fees are a concern.
        </Text>
      </Disclaimer>
      <Disclaimer
        index={2}
        title="Disclaimer 2"
        accepted={!!disclaimer2Accepted}
        onCompleted={index => handleCompleted(index as 1 | 2)}>
        <span
          style={{
            textDecoration: 'underline',
            fontWeight: 500,
          }}>
          I accept and understand the following:
        </span>
        <UnorderedList mt={2} px={2} spacing={3}>
          <DisclaimerListItem>
            Hamilton Billing is providing me with an assessment <Bold>only</Bold> and not a
            guarantee of coverage from my plan
          </DisclaimerListItem>
          <DisclaimerListItem>
            The assessment I am receiving is based on a good faith estimate for comprehensive,
            preventive maternity care.
          </DisclaimerListItem>
          <DisclaimerListItem>
            The provider I have contacted is non-participating with any insurer, therefore
            ultimately, I agree to be responsible for any balance my insurer may not cover towards
            care should I sign up for services.
          </DisclaimerListItem>
          <DisclaimerListItem>
            Hamilton Billing is not responsible for outcomes on coverage or reimbursement from my
            plan that differ from any assessment provided.
          </DisclaimerListItem>
          <DisclaimerListItem>
            Hamilton Billing does not work for any insurance company, nor can they predict future
            changes in my plan coverage nor decisions made by my insurer in the processing of
            claims.
          </DisclaimerListItem>
        </UnorderedList>
      </Disclaimer>
    </VStack>
  )
}

const bodyProps: DefaultModalProps['bodyProps'] = {
  px: 3,
  py: 4,
}
export const AssessmentDisclaimersModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) => (
  <DefaultModal
    size="2xl"
    isOpen={isOpen}
    onClose={onClose}
    overlayHeader
    render={() => <AssessmentDisclaimers />}
    bodyProps={bodyProps}
  />
)
